import { useSelector } from 'react-redux';
import { ReactNode } from 'react';
import { Navigate } from 'react-router'; // Updated import
// material
import { Box } from '@material-ui/core';
//
import HomeNavbar from './HomeNavbar';
import { RootState } from '../../redux/store';
import { PATH_AUTH } from '../../routes/paths';

// ----------------------------------------------------------------------

type HomeLayoutProps = {
  children: ReactNode;
};

export default function HomeLayout({ children }: HomeLayoutProps) {
  const company: any = useSelector(
    (state: RootState) => state.generalRecruiter.company
  );

  // Use Navigate instead of Redirect
  if (!company.active) return <Navigate to={PATH_AUTH.login} replace />;

  return (
    <Box sx={{ height: '100%' }}>
      <HomeNavbar logo={company.logo} />
      <Box sx={{ height: '100%' }}>{children}</Box>
    </Box>
  );
}
